import { useMutation } from '@apollo/client';
import mutation from 'client/mutations/isUserExist';

export default function useIsUserExist() {
  return useMutation(mutation);
}
